import React from 'react';
import ToastrContent from 'components/toastr/ToastrContent';
import { toastr } from 'react-redux-toastr';

const buildToastrContent = (text: Array<string>, link ?: string, listTitle ?: string) => {
  if (text && text.join('') === '') {
    return null;
  }

  let content;

  if (text.length <= 1) {
    content = text;
  } else {
    // Use bullets to display array of string
    content = [];
    for (let i = 0; i < text.length; i += 1) {
      content.push(<li key={i}>{text[i]}</li>);
    }
    content = (
      <ul>
        {content}
      </ul>
    );
  }

  // Applies non-empty listTitle if text is an array of string
  if (listTitle && listTitle !== '') {
    content = (
      <div>
        {listTitle}
        {content}
      </div>
    );
  }

  // If link is available, wrap it with `a` tag
  if (link) {
    content = (
      <a href={link}>
        {content}
      </a>
    );
  }

  return (
    <ToastrContent>{content}</ToastrContent>
  );
};

const Toastr = {
  success: (text: string | Array<string>, link ?: string, listTitle ?: string) => {
    Toastr.spawn('success', text, link, listTitle);
  },
  error: (text: string | Array<string>, link ?: string, listTitle ?: string) => {
    Toastr.spawn('error', text, link, listTitle);
  },
  info: (text: string | Array<string>, link ?: string, listTitle ?: string) => {
    Toastr.spawn('info', text, link, listTitle);
  },
  spawn: (type: string, text: string | Array<string>, link ?: string, listTitle ?: string) => {
    if (!Array.isArray(text)) {
      text = [text];
    }

    const content = buildToastrContent(text, link, listTitle);

    if (!content) {
      return;
    }

    switch (type) {
      case 'success':
        toastr.success('', '', {
          component: content,
        });
        break;
      case 'error':
        toastr.error('', '', {
          component: content,
        });
        break;
      case 'info':
        toastr.info('', '', {
          component: content,
        });
        break;
      default:
        console.error(`Unknown toastr type: \`${type}\``);
    }
  },
};

export default Toastr;
